// Clover handles payments in 4 ways, however a Credit is just a -ve Payment and both are created by calls to the same
// API endpoint.
const CloverTransactionType = Object.freeze({
    CREDIT: 'CREDIT',
    PAYMENT: 'PAYMENT',
    REFUND: 'REFUND',
    VOID: 'VOID',
});

module.exports = CloverTransactionType;
